<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Nova baixa"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidades"
                        disabled
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.salasVacinacao"
                        disabled
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.salaVacinacaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :value="inputVacinaValue"
                        disabled
                        label="Vacina"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.tipos"
                        :validations="validations.tipoId"
                        label="Tipo"
                        show-default-option
                        text-field="nome"
                        v-model="model.tipoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col
                    v-if="model.tipoId === enums.saidaTipo.INDISPONIBILIDADE"
                    cols="6"
                >
                    <rkm-form-input
                        :validations="validations.motivoIndisponibilidade"
                        label="Motivo da indisponibilidade"
                        v-model="model.motivoIndisponibilidade"
                    />
                </rkm-col>

                <rkm-col
                    v-else
                    cols="6"
                >
                    <rkm-form-select
                        :options="form.motivos"
                        :validations="validations.motivoId"
                        label="Motivo"
                        show-default-option
                        text-field="nome"
                        v-model="model.motivoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.motivoId === enums.saidaMotivo.USO_EM_APLICAÇÃO">
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observação"
                        rows="3"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-date-picker
                        disabled
                        label="Data"
                        v-model="model.dataSaida"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.lotes"
                        :validations="validations.lote"
                        @change="handleLoteChange"
                        label="Lote"
                        show-default-option
                        v-model="model.lote"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        disabled
                        label="Estoque"
                        type="number"
                        v-model="model.estoque"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!model.lote"
                        :validations="validations.quantidade"
                        label="Quantidade"
                        type="number"
                        v-model="model.quantidade"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="saveAndPrint"
                color="success"
            >
                Salvar e imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'
import saidaMotivo from '@/enums/imunizacao/saidaMotivo'
import saidaTipo from '@/enums/imunizacao/saidaTipo'

// Mixins.
import { error, repository, file, stringCase } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {
            return {
                tipoId: { required: true },
                motivoId: { required: true },
                motivoIndisponibilidade: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                observacao: {
                    min: 3,
                    max: 300,
                },
                quantidade: {
                    required: true,
                    min_value: this.model.estoque ? 1 : 0,
                    max_value: this.model.estoque ?? 0,
                    max: 8,
                },
                lote: { required: true },
            }
        },
        inputVacinaValue() {
            let value = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    value = this.model.vacinaAbreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    value = this.model.vacinaSigla
                    break;

                    case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    value = this.model.vacinaSiglaNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    value = this.model.vacinaSiglaAbreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.model.vacinaAbreviacaoNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.model.vacinaSiglaAbreviacaoNome
                    break;

                default:
                    value = this.model.vacinaNome
                    break;
            }

            return value
        },
    },
    created() {
        this.repositories = {
            baixa: this.getConectaSusRepository('imunizacao.baixa'),
            impressao: this.getConectaSusRepository('impressao.imunizacao'),
        }
    },
    data: () => ({
        additionals: null,
        enums: {
            parametrizacaoDescricaoVacina,
            saidaMotivo,
            saidaTipo,
        },
        form: null,
        model: null,
        others: { moment },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.load(item)
            this.$refs.RkmModal.show()
        },
        load(item) {
            const request = {
                tipoMovimentacao: 'baixa',
                salaVacinacaoId: item.salaVacinacaoId,
                vacinaId: item.vacinaId,
            }

            this.setLoading()

            this.repositories.baixa.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.form.lotes = this.form.lotes.map(lote => {
                        return {
                            text: `${lote.lote} - Val: ${this.others.moment(lote.dataValidadeLote).format('DD/MM/YYYY')}`,
                            value: lote,
                        }
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleLoteChange(value) {
            this.model.estoque = null
            this.model.quantidade = null

            if (this.model.lote === null) return

            const request = {
                listar: 'estoque',
                salaVacinacaoId: this.model.salaVacinacaoId,
                vacinaId: this.model.vacinaId,
                lote: value.lote,
                dataValidadeLote: value.dataValidadeLote,
            }

            this.setLoading()

            this.repositories.baixa.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.model.estoque = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        tipoMovimentacao: 'baixa',
                        salaVacinacaoId: this.model.salaVacinacaoId,
                        vacinaId: this.model.vacinaId,
                        tipoId: this.model.tipoId,
                        motivoId: this.model.motivoId,
                        motivoIndisponibilidade: this.model.motivoIndisponibilidade,
                        observacao: this.model.observacao,
                        dataSaida: this.others.moment(this.model.dataSaida).format('DD/MM/YYYY'),
                        lote: this.model.lote.lote,
                        dataValidadeLote: this.model.lote.dataValidadeLote,
                        quantidade: this.model.quantidade,
                    }

                    this.repositories.baixa.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(() => {
                            this.showSaveNotification()
                            this.handleExit()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        saveAndPrint() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        tipoMovimentacao: 'baixa',
                        salaVacinacaoId: this.model.salaVacinacaoId,
                        vacinaId: this.model.vacinaId,
                        tipoId: this.model.tipoId,
                        motivoId: this.model.motivoId,
                        motivoIndisponibilidade: this.model.motivoIndisponibilidade,
                        observacao: this.model.observacao,
                        dataSaida: this.others.moment(this.model.dataSaida).format('DD/MM/YYYY'),
                        lote: this.model.lote.lote,
                        dataValidadeLote: this.model.lote.dataValidadeLote,
                        quantidade: this.model.quantidade,
                    }

                    this.repositories.baixa.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then((id) => {
                            this.showSaveNotification()
                            this.print(id.data)
                            this.handleExit()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        print(id) {
            this.setLoading()

            return this.repositories.impressao.baixa(id)
                .then(response => {
                    this.openFile(response.data, response.headers['content-type'])
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {
            this.$emit('save')
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [ error, repository, file, stringCase ],
    watch: {
        'model.tipoId'() {
            this.model.motivoId = null
            this.model.motivoIndisponibilidade = null
            this.model.observacao = null
        },
        'model.motivoId'() {
            this.model.observacao = null
        },
    },
}
</script>